import script from "./AnnounceSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnounceSlider.vue?vue&type=script&setup=true&lang=js"

import "./AnnounceSlider.vue?vue&type=style&index=0&id=6a7729bc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7729bc"]])

export default __exports__